import React from "react";

import Toyota_Footer_logo from "../../images/Toyota_Footer_Logo.svg";

const Footer = () => {
  return (
    <div className="page-footer">
      <div className="container">
        <div className="top-wrap">
          <img className="toyota-logo" src={Toyota_Footer_logo} />
          <div className="copyright">© 2024 Toyota New Zealand</div>
          <div className="footer-links">
            <a
              className="links"
              href="https://www.toyota.co.nz/legal-and-privacy-policy/"
            >
              Legal & Privacy Policy
            </a>
          </div>
        </div>
        <div className="footer-text">
          <p>
            Vehicles represented on this site are for composition purposes only. The vehicles do not necessarily represent current model-year options or specifications. Please see your local dealer or <a
              className="links"
              href="https://www.toyota.co.nz"
            >toyota.co.nz</a> for product offerings.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
